// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1XN9_","boxTitle":"Qualiphy_boxTitle__2-rro","box":"Qualiphy_box__szw7Q","toggleWrap":"Qualiphy_toggleWrap__1-6rs"};